import { httpRequest } from "@services/http";

export interface Role {
  id: number;
  name: string;
  /** Present once the server side of MPN-1606 is deployed. Nothing reads it
   *  yet -- the filtering is done server-side -- but it is part of the response. */
  is_customer_role?: boolean;
}

export class CommandListRoles {
  /** Scoped to an organization, the server returns only the roles assignable
   *  there: the four customer roles for a client, everything for Motimatic
   *  (MPN-1606). Omit it for the role administration screens. */
  async run(organizationId?: number): Promise<Role[]> {
    const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/roles/`;
    const url = organizationId ? `${base}?organization_id=${organizationId}` : base;
    try {
      return await httpRequest<Role[]>(url, { method: "GET" });
    } catch (error) {
      console.error("Error fetching roles:", error);
      throw error;
    }
  }
}
